import { render, staticRenderFns } from "./IncomingPDC.vue?vue&type=template&id=e22b2392"
import script from "./IncomingPDC.vue?vue&type=script&lang=js"
export * from "./IncomingPDC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports